module.exports = __webpack_public_path__ + "img/meridiani.eba91648.png";